<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'vaccinationDocument_approvalTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <section class="block-em">
        <div class="data-value">
            <label>{{'vaccinationDocument_lblType' | translate}}</label>
            <div>{{document.Type}}</div>
        </div>

        <div class="data-value">
            <label>{{'vaccinationDocument_lblExpires' | translate}}</label>
            <div>{{document.Expires | appDate}}</div>
        </div>

        <div class="data-value">
            <label>{{'vaccinationDocument_lblPerson' | translate}}</label>
            <div>{{document.OwnerFullName}} ({{document.OwnerUserName}})</div>
        </div>

        <div class="data-value">
            <label>{{'vaccinationDocument_lblNotes' | translate}}</label>
            <div>{{document.Notes}}</div>
        </div>

        <div class="data-value">
            <label>{{'vaccinationDocument_lblFile' | translate}}</label>
            <div>
                <a href="#" (click)="$event.preventDefault(); download()">
                    {{document.FileName}}
                </a>
            </div>
        </div>
    </section>

    <form #form="ngForm">
        <div class="form-field required">
            <label class="form-label">{{'vaccinationDocument_lblDecision' | translate}}</label>
            <div *ngFor="let n of actions" class="mb-1">
                <app-radio [(ngModel)]="action" [value]="n" name="action-{{n}}">
                    {{('vaccinationDocument_approvalAction' + n) | translate}}
                </app-radio>
            </div>
        </div>

        <div class="form-field required" *ngIf="isCommentRequired">
            <label class="form-label">{{'vaccinationDocument_lblApprovalComment' | translate}}</label>
            <textarea class="form-control"
                      [(ngModel)]="comment"
                      name="notes"
                      rows="5"
                      #commentInput="ngModel"
                      required
                      [pattern]="getMaxLengthValidationPattern(comment, commentMaxLength)"></textarea>
            <div class="feedback" *ngIf="!comment?.length || commentInput.valid">{{(comment || '').length}}/{{commentMaxLength}}</div>
            <div class="invalid-feedback" *ngIf="comment?.length && commentInput.invalid">
                {{'fieldError_lengthMinMax' | translate | formatString:[0, commentMaxLength]}}
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="isSaving">{{'cancel' | translate}}</button>

    <button class="btn btn-primary" (click)="submit()" type="button" [disabled]="!form.valid || isSaving">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'continue' | translate}}
    </button>
</div>
